import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
	mode: 'history',
    routes: [
		{
		    path: '/',
		    redirect: '/treasure'
		},
		{
		    path: '/main',
		    component: () => import( '../components/page/main.vue'),
		    meta: { title: '首页' }
		},
		{
		    path: '/chargingjoin',
		    component: () => import( '../components/page/chargingjoin.vue'),
		    meta: { title: '共享充电宝加盟' }
		},
		{
		    path: '/cable',
		    component: () => import( '../components/page/cable.vue'),
		    meta: { title: '共享充电线' }
		},
		{
		    path: '/powerbank',
		    component: () => import( '../components/page/powerbank.vue'),
		    meta: { title: '热度充电宝' }
		},
		{
		    path: '/product',
		    component: () => import( '../components/page/product.vue'),
		    meta: { title: '产品展示' }
		},
		{
		    path: '/aboutmy',
		    component: () => import( '../components/page/aboutmy.vue'),
		    meta: { title: '关于我们' }
		},
		{
		    path: '/treasure',
		    component: () => import( '../components/page/treasure.vue'),
		    meta: { title: '酒店宝' }
		},
		
		
		
		
	],
	
	});
	
	const VueRouterPush = Router.prototype.push
	Router.prototype.push = function push (to) {
	  return VueRouterPush.call(this, to).catch(err => err)
	  }